import request from "@/utils/request";
const baseApi = process.env.VUE_APP_BASE_API_AUTH;
export function token(data) {
  return request({
    url: baseApi + "/auth/login/",
    method: "post",
    data,
  });
}

export function refresh(data) {
  return request({
    url: baseApi + "/auth/refresh/",
    method: "post",
    data,
  });
}

export function logout() {
  return request({
    url: baseApi + "/auth/logout/",
    method: "post",
  });
}
